import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { message } from 'antd';
import { Alert } from 'antd';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getPeriode, deletePeriode } from './periode-evaluation.reducer';

export const PeriodeEvaluationDeleteDialog = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId?: string; id: string }>) => {
  const { ecoleid, anneeScolaireId, id } = props.match.params;
  const dispatch = useAppDispatch();
  const [deleteError, setDeleteError] = useState<string | null>(null);

  useEffect(() => {
    dispatch(getPeriode(id));
  }, []);

  const periodeEntity = useAppSelector(state => state.periodeEvaluation.entity);
  const updateSuccess = useAppSelector(state => state.periodeEvaluation.updateSuccess);

  const handleClose = () => {
    props.history.push(anneeScolaireId ? `/periode-evaluation/${ecoleid}/${anneeScolaireId}` : `/periode-evaluation/${ecoleid}`);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    if (!periodeEntity.anneeScolaireId || !periodeEntity.cycleId) return;

    dispatch(
      deletePeriode({
        id,
        ecoleId: ecoleid,
        anneeScolaireId: periodeEntity.anneeScolaireId,
        cycleId: periodeEntity.cycleId,
      })
    );
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="periodeDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="korischoolApp.periodeEvaluation.delete.question">
        <Translate contentKey="korischoolApp.periodeEvaluation.delete.question" interpolate={{ id: periodeEntity.nom }}>
          Are you sure you want to delete this Period?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-periode" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PeriodeEvaluationDeleteDialog;
